/** @jsxImportSource @emotion/react */

export type TextFilterValue = {
  option: 'is_equal_to' | 'contains' | 'starts_with' | 'ends_with';
  text: string;
};

export const defaultTextFilter: TextFilterValue = {
  option: 'is_equal_to',
  text: '',
};

export type TextFilterProps = {
  value: TextFilterValue | null;
  conditions?: string[];
  onChange(value: TextFilterValue): void;
};

export function TextFilter({ onChange, ...props }: TextFilterProps) {
  const value = props.value ?? defaultTextFilter;
  const conditions = props.conditions;

  return (
    <>
      {conditions && conditions.length > 1 && (
        <div className="lp-w-full mb-16">
          <div className="selectdropdown">
            <select
              data-testid="text-filter-type-select"
              className="form-control"
              value={value.option}
              onChange={({ target: { value: option } }) => onChange({ option, text: '' } as TextFilterValue)}
            >
              {!conditions || conditions.includes('is_equal_to') ? (
                <option value="is_equal_to">is equal to</option>
              ) : (
                ''
              )}
              {!conditions || conditions.includes('contains') ? <option value="contains">contains</option> : ''}
              {!conditions || conditions.includes('starts_with') ? (
                <option value="starts_with">starts with</option>
              ) : (
                ''
              )}
              {!conditions || conditions.includes('ends_with') ? <option value="ends_with">ends with</option> : ''}
            </select>
          </div>
        </div>
      )}
      <div className="lp-w-full lp-flex lp-align-center mb-0">
        <div className="lp-w-full ml-16px">
          <input
            type="text"
            className="form-control"
            style={{ width: '100%' }}
            value={value.text}
            onChange={({ target: { value: text } }) => onChange({ ...value, text })}
            data-testid="text-filter-text-input"
          />
        </div>
      </div>
    </>
  );
}
